export const enum ActivityDetailsPanelType {
  None = 'none',
  TicketsSelection = 'ticketsSelection',
}
